var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReflector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 128,
    viewBox: "0 0 197 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 197,
    height: 128,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.25 13C114.25 11.8954 115.145 11 116.25 11H128C129.105 11 130 11.8954 130 13V90.5365C130 91.6411 129.105 92.5365 128 92.5365H114.25V13Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109 43.5762C109 42.4716 109.895 41.5762 111 41.5762H114.25V92.5365H109V43.5762Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6805 82.2242C84.9934 81.1649 86.1097 80.5462 87.1738 80.8424L110.48 87.3293L109.033 92.2279L83.8 85.2048L84.6805 82.2242Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.71 82.0769C84.2234 81.099 85.4422 80.7032 86.4323 81.1929L89.3173 82.62L72.6073 114.449C72.0939 115.427 70.875 115.822 69.885 115.333L68.7927 114.792C67.8026 114.303 67.4162 113.113 67.9297 112.135L83.71 82.0769Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReflector);
export default __webpack_public_path__ + "static/media/Reflector.dcf27a0a1f8bdb9bce37dbea0030155c.svg";
export { ForwardRef as ReactComponent };